import React from "react";
import ReactDOM from "react-dom/client";
// import "./Expense/App.css";
// import "./components/1.css"
// import "./index.css"
import "./index.css"
import App from "./App";
import { Suspense } from "react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode >
      <Suspense fallback={<div>Loading ...</div>}>

<App />

</Suspense>
  </React.StrictMode>
);

